// Organisation-level API (org admins). The bearer token is attached globally by
// AuthContext, so nothing here sets headers.
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const BASE = `${API_URL}/api/v1/org`;

export const getOrganization = () => axios.get(BASE).then((r) => r.data);
export const updateOrganization = (body) => axios.put(BASE, body).then((r) => r.data);

export const getDashboard = () => axios.get(`${BASE}/dashboard`).then((r) => r.data);

export const listSites = () => axios.get(`${BASE}/sites`).then((r) => r.data);
export const listRegions = () => axios.get(`${BASE}/regions`).then((r) => r.data);
export const getSite = (id) => axios.get(`${BASE}/sites/${id}`).then((r) => r.data);
export const createSite = (body) => axios.post(`${BASE}/sites`, body).then((r) => r.data);
export const updateSite = (id, body) => axios.put(`${BASE}/sites/${id}`, body).then((r) => r.data);
export const setSiteStatus = (id, isActive) =>
  axios.patch(`${BASE}/sites/${id}/status`, { is_active: isActive }).then((r) => r.data);

export const listMembers = () => axios.get(`${BASE}/members`).then((r) => r.data);
// The complete set of sites this person should hold `role` at — the server reconciles,
// granting what's new and revoking what was unticked.
export const assignMember = (userId, role, clinicIds) =>
  axios.put(`${BASE}/members/${userId}/assign`, { role, clinic_ids: clinicIds })
    .then((r) => r.data);

// AI credits. The organisation holds a pool; allocating moves sessions from it to a
// site, and a negative number takes them back.
export const getCredits = () => axios.get(`${BASE}/credits`).then((r) => r.data);
export const allocateCredits = (clinicId, sessions, note) =>
  axios.post(`${BASE}/credits/allocate`, { clinic_id: clinicId, sessions, note })
    .then((r) => r.data);
export const setSiteUnlimited = (clinicId, unlimited) =>
  axios.post(`${BASE}/credits/unlimited`, { clinic_id: clinicId, unlimited })
    .then((r) => r.data);

export const listOrgAdmins = () => axios.get(`${BASE}/admins`).then((r) => r.data);
// The sites where an organisation admin also practises as a provider. The list is the
// whole answer — sites left out lose the role.
export const setOrgAdminProviderSites = (userId, clinicIds) =>
  axios.put(`${BASE}/admins/${userId}/provider`, { clinic_ids: clinicIds }).then((r) => r.data);
export const addOrgAdmin = (body) => axios.post(`${BASE}/admins`, body).then((r) => r.data);
export const removeOrgAdmin = (userId) =>
  axios.delete(`${BASE}/admins/${userId}`).then((r) => r.data);
